<template>
  <div v-if="loaded">
    <Mail
      :emails_list="document.emails"
      :attached_files="[
        {
          object: object,
          document: document,
        },
      ]"
      :body="body"
      @close="$emit('close', $event)"
    >
    </Mail>
  </div>
</template>

<script>
import documents from "@/services/documents";
import Mail from "@/components/Mail.vue";
export default {
  name: "DocumentMail",
  components: {
    Mail,
  },
  props: {
    object: [String],
    document_id: [Number, String],
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      document: {},
      body: `Cabinet De Greft

Rue Chantraine 158/021
B-4420 SAINT-NICOLAS

TEL.: 0032 4 254 05 50
FAX: 0032 4 252 22 13
TVA : BE0478434880
IBAN: BE43 3630 4182 2501
BIC: BBRUBEBB`,
      loaded: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      documents
        .get_single(this.$props.object, this.$props.document_id)
        .then((response) => {
          this.document = response.data;
          this.loaded = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>